// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pageError-background[data-v-83eff5fa]{font-size:20vw;line-height:1;color:#e0e0e0;font-weight:700}.pageError-title[data-v-83eff5fa]{font-size:18px}", ""]);
// Exports
module.exports = exports;
